<template>
	<div v-if="rowContent[1]" :class="getProductClass(rowContent)">
		<div class="product-info-content inner-tabs">
			<div class="about-product">
				<ul :class="rowContent[1].product_class" class="nav nav-tabs full select-pc-tab">
					<li v-if="rowContent[1]" :class="{ [rowTitle1]: true, disabled: disabledRules[rowId1] }">
						<a
							:class="{ 'disable-element': isLoading || disableButton }"
							:href="'#' + rowContent[1].products_id"
							@click.prevent="addCaseToBuild(rowContent[1])"
						>
							<span class="helper-picker"/>
							<h5 v-if="rowContent[0]" class="text-white">
								{{ rowContent[1].title }}
								{{ getPrice(rowContent[1]) }}
							</h5>
							<h5 v-else class="text-white">{{ rowContent[1].title }}</h5>
						</a>
					</li>
					<li :class="{ [rowTitle0]: true, disabled: disabledRules[rowId0] }">
						<a
							:class="{ 'disable-element': isLoading || disableButton }"
							:href="'#' + rowContent[0].products_id"
							@click.prevent="addCaseToBuild(rowContent[0])"
						>
							<span class="helper-picker"/>
							<h5 class="text-white">
								{{ rowContent[0].title }}
								{{ getPrice(rowContent[0]) }}
							</h5>
						</a>
					</li>
				</ul>
			</div>
			<div class="about-product">
				<div class="tab-content">
					<div v-if="rowContent[1]" :id="rowContent[1].products_id" :class="{ [rowContent1]: true, disabled: disabledRules[rowId1] }">
						<div :class="{ disabled: allDisabled }" class="product-image">
							<img :src="rowContent[1].image" alt="">
						</div>
						<p class="part-description">
							{{ truncate(rowContent[1].description) }}
							<a href="#" @click="openDetailsModal(rowContent[1])">MORE INFO</a>
						</p>
						<div class="cant-select">
							<row-buttons
								v-if="!disabledRules[rowId1] && !tabDisabled"
								:buttons-type="buttonsType"
								:can-deselect="rowStructure.canDeselect"
								:part-info="rowContent[1]"
								:part-name="partName"
								:row-structure="rowStructure"
							/>
							<disabled-button v-else :buttons-type="buttonsType" />
						</div>
						<disabled-message v-if="disabledRules[rowId1]" :css-classes="{ 'all-disabled': allDisabled }" :message="disabledRules[rowId1]" />
					</div>
					<div :id="rowContent[0].products_id" :class="{ [rowContent0]: true, disabled: disabledRules[rowId0] }">
						<div :class="{ disabled: allDisabled }" class="product-image">
							<img :src="rowContent[0].image" alt="">
						</div>
						<p class="part-description">
							{{ truncate(rowContent[0].description) }}
							<a href="#" @click="openDetailsModal(rowContent[0])">MORE INFO</a>
						</p>
						<div class="cant-select">
							<row-buttons
								v-if="!disabledRules[rowId0] && !tabDisabled"
								:buttons-type="buttonsType"
								:can-deselect="rowStructure.canDeselect"
								:part-info="rowContent[0]"
								:part-name="partName"
								:row-structure="rowStructure"
							/>
							<disabled-button v-else :buttons-type="buttonsType" />
						</div>
						<disabled-message v-if="disabledRules[rowId0]" :css-classes="{ 'all-disabled': allDisabled }" :message="disabledRules[rowId0]" />
					</div>
				</div>
			</div>
		</div>
	</div>
	<div v-else :class="{ [getProductClass(rowContent)]: true, disabled: disabledRules[rowId0] }">
		<div class="product-info-content">
			<div :class="{ disabled: allDisabled }" class="product-image">
				<img :src="rowContent[0].image" alt="">
			</div>
			<div class="about-product">
				<h5
					:class="{ 'disable-element': isLoading || disableButton }"
					class="text-white"
					@click="addCaseToBuild(rowContent[0])"
				>
					{{ rowContent[0].title }}
				</h5>
				<p class="part-description">
					{{ truncate(rowContent[0].description) }}
					<a href="#" @click="openDetailsModal(rowContent[0])">MORE INFO</a>
				</p>
			</div>
		</div>
		<div class="cant-select">
			<row-buttons
				v-if="!disabledRules[rowId0] && !tabDisabled"
				:buttons-type="buttonsType"
				:can-deselect="rowStructure.canDeselect"
				:part-info="rowContent[0]"
				:part-name="partName"
				:row-structure="rowStructure"
			/>
			<disabled-button v-else :buttons-type="buttonsType" />
		</div>
		<disabled-message v-if="disabledRules[rowId0]" :message="disabledRules[rowId0]" />
	</div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import _intersectionWith from "lodash/intersectionWith";
import duplicate from "@m/duplicate";
import DisabledButton from "./components/disabled-button";
import DisabledMessage from "./components/disabled-message";
import RowButtons from "./components/row-buttons";
export default {
	name: "TabRowInnerTabs",
	components: {
		DisabledButton,
		DisabledMessage,
		RowButtons
	},
	mixins: [
		duplicate
	],
	props: {
		buttonsType: {
			type: String,
			default: ""
		},
		partName: {
			type: String,
			default: ""
		},
		rowContent: {
			type: Array,
			default() {
				return [];
			}
		},
		rowStructure: {
			type: Object,
			default() {
				return {};
			}
		},
		tabDisabled: {
			type: Boolean,
			required: true
		},
		tabSlug: {
			type: String,
			required: true
		}
	},
	data() {
		return {
			disableButton: false
		};
	},
	computed: {
		...mapState({
			activeBuild: state => state.Step4.activeBuild,
			disableRules: state => state.Step4.disableRules,
			isLoading: state => state.Step4.isLoading
		}),
		allDisabled() {
			return Object.keys(this.disabledRules).length == 2;
		},
		disabledRules() {
			const disabledRules = {};

			this.rowContent.forEach(row => {
				const rule = this.disableRules.find(rule => rule.ruleType == "disable" && rule.partToChange == this.tabSlug && rule.products.products_id == row.products_id && rule.products.id == row.id);

				if (rule) {
					disabledRules[`${row.products_id}-${row.id}`] = rule.msg;
				}
			});

			return disabledRules;
		},
		rowTitle0() {
			return this.getActiveTabClass(this.rowContent[0]);
		},
		rowTitle1() {
			return this.getActiveTabClass(this.rowContent[1]);
		},
		rowContent0() {
			return this.getTabPaneClass(this.rowContent[0], 0);
		},
		rowContent1() {
			return this.getTabPaneClass(this.rowContent[1], 1);
		},
		rowId0() {
			return `${this.rowContent[0].products_id}-${this.rowContent[0].id}`;
		},
		rowId1() {
			return `${this.rowContent[1].products_id}-${this.rowContent[1].id}`;
		}
	},
	watch: {
		isLoading(state) {
			if (state == false) {
				this.disableButton = state;
			}
		}
	},
	methods: {
		...mapActions([
			"changeBuildPart",
			"changeLoadingState",
			"setBuildPrice",
			"pushBuildPart",
			"removeBuildPart",
			"setPreviousBuild",
			"changeActiveRules",
			"changePreventRuleValidator",
			"setPreviousPartQuantity",
			"changePartDetails"
		]),
		async addCaseToBuild(selectedCase) {
			if (await this.checkOwnership()) {
				this.disableButton = true;
				this.changeLoadingState(true);
				axios({
					url: `/update-part/${selectedCase.id}/${this.activeBuild["case"].id}?pid=${selectedCase.products_id}&validate=true&step4=true`,
					method: "GET",
					headers: {
						"token": CONFIG.SESSION
					}
				}).then(response => {
					this.changeLoadingState(false);
					this.changeBuildPrice(response.data);
				});
			} else {
				await this.duplicateBuild();
				await this.getSessionData();
				this.addCaseToBuild(selectedCase);
			}
		},
		changeBuildPrice(pricingData) {
			if (pricingData.total) {
				if (pricingData.rules) {
					this.changeActiveRules(pricingData.rules);
				}
				this.$store.dispatch("setActiveBuild", pricingData.build);
				this.setBuildPrice(pricingData.total);
			} else {
				if (pricingData.price) {
					this.setBuildPrice(pricingData.price);
				} else {
					this.setBuildPrice(pricingData);
				}
			}
		},
		getActiveTabClass(part) {
			let refId = "products_id";

			if (this.partName == "case") {
				if (+this.activeBuild[this.partName].is_limited) {
					if (this.rowStructure.id == "case-options") {
						return "";
					} else {
						refId = "id";
					}
				} else {
					if (this.rowStructure.id == "limited-cases") {
						return "";
					}
				}
			}

			if (!Array.isArray(this.activeBuild[this.partName])) {
				if (this.activeBuild[this.partName][refId] == part[refId]) {
					return "active";
				}
			} else {
				const selectedPart = this.activeBuild[this.partName].find(
					item => item.products_id == part.products_id && item.id == part.id
				);

				if (selectedPart) {
					return "active";
				}
			}

			return "";
		},
		getTabPaneClass(part, partIndex) {
			if (this.rowStructure.id == "case-options") {
				if (+this.activeBuild[this.partName].is_limited) {
					if (partIndex == 1) {
						return "tab-pane active";
					} else {
						return "tab-pane";
					}
				}

				if (this.activeBuild[this.partName].cases_series_id == part.cases_series_id && this.activeBuild[this.partName].products_id == part.products_id) {
					return "tab-pane active";
				} else if (this.activeBuild[this.partName].cases_series_id != part.cases_series_id && partIndex == 1) {
					return "tab-pane active";
				} else {
					return "tab-pane";
				}
			}

			if (!Array.isArray(this.activeBuild[this.partName])) {
				if (this.activeBuild[this.partName].products_id == part.products_id) {
					return "tab-pane active";
				}

				if (!this.rowContent.some(item => item.products_id == this.activeBuild[this.partName].products_id) && partIndex == 1) {
					return "tab-pane active";
				}
			} else {
				const selectedPart = this.activeBuild[this.partName].find(
					item => item.products_id == part.products_id
				);

				if ((selectedPart && selectedPart.id == part.id) || (!selectedPart && partIndex == 1)) {
					return "tab-pane active";
				}
			}

			return "tab-pane";
		},
		getPrice(part) {
			const partPrice = part.price;
			let price = part.price;
			let refId = "products_id";

			if (price == "0.00") {
				return price;
			}

			if (Array.isArray(this.activeBuild[this.partName])) {
				const selectedPart = this.activeBuild[this.partName].find(
					item => item.products_id == part.products_id
				);

				if (!selectedPart) {
					return "";
				}

				price = Number(partPrice) * Number(selectedPart.quantity)
                    - Number(selectedPart.price) * Number(selectedPart.quantity);
				price = Number.parseFloat(price).toFixed(2);

				let results = price == 0 && selectedPart.id == part.id ? "Selected" : price > 0 ? `+$${Math.trunc(price)}` : `-$${Math.trunc(price * -1)}`;

				if (results == "-$0") {
					results = "Selected";
				}

				if (this.rowContent.find(row => row.id == selectedPart.id)) {
					if (results != "Selected") {
						return `(${results})`;
					} else if (results == "Selected") {
						return "";
					}

					return results;
				}

				return "";
			}

			if (this.activeBuild[this.partName] && this.activeBuild[this.partName].price) {
				if (this.activeBuild[this.partName].quantity) {
					price = Number(partPrice) * Number(this.activeBuild[this.partName].quantity)
                        - Number(this.activeBuild[this.partName].price) * Number(this.activeBuild[this.partName].quantity);
				} else {
					price = Number(partPrice) - Number(this.activeBuild[this.partName].price);
				}
			}

			price = Number.parseFloat(price).toFixed(2);

			if (this.partName == "case") {
				if (+this.activeBuild[this.partName].is_limited) {
					if (this.rowStructure.id == "case-options") {
						return "";
					} else {
						refId = "id";
					}
				} else {
					if (this.rowStructure.id == "limited-cases") {
						return price == 0 ? "$0" : (price > 0 ? `+$${price}` : `-$${price * -1}`);
					}
				}
			}

			let results = price == 0 && this.activeBuild[this.partName][refId] == part[refId] ? "Selected" : price > 0 ? `+$${Math.trunc(price)}` : `-$${Math.trunc(price * -1)}`;

			if (results == "-$0") {
				results = "Selected";
			}

			if (this.rowContent.find(row => row[refId] == this.activeBuild[this.partName][refId])) {
				if (results != "Selected") {
					return `(${results})`;
				} else if (results == "Selected") {
					return "";
				}

				return results;
			}

			return "";
		},
		getProductClass(parts) {
			let refId = "products_id";

			if (this.partName == "case") {
				if (+this.activeBuild[this.partName].is_limited) {
					if (this.rowStructure.id == "case-options") {
						return "product-data p-x";
					} else {
						refId = "id";
					}
				} else {
					if (this.rowStructure.id == "limited-cases") {
						return "product-data p-x";
					}
				}
			}

			if (!Array.isArray(this.activeBuild[this.partName])) {
				if (parts.find(part => part[refId] == this.activeBuild[this.partName][refId])) {
					return "product-data p-x selected";
				}
			} else {
				if (_intersectionWith(parts, this.activeBuild[this.partName], (a, b) => a.id == b.id).length) {
					return "product-data p-x selected";
				}
			}

			return "product-data p-x";
		},
		truncate(text, length = 120, etc = "…", breakWords = false, remaining = false) {
			let truncatedText = "";

			if (!length) {
				return truncatedText;
			}

			if (etc == "...") {
				etc = "…";
			}

			if (text.length > length) {
				if (!breakWords) {
					truncatedText = text.substr(0, length).replace(/\s+?(\S+)?$/, "") + etc;
				} else {
					truncatedText = text.substr(0, length).replace(/\s*$/, "") + etc;
				}
			} else {
				truncatedText = text;
			}

			if (remaining) {
				truncatedText = [truncatedText, text.substr(truncatedText.length - etc.length)];
			}

			return truncatedText;
		},
		openDetailsModal(part) {
			this.changePartDetails(
				{
					show: true,
					id: part.products_id,
					variantId: part.id
				}
			);
			$("#parts-details-modal").modal();
		}
	}
};
</script>

<style lang="scss" scoped>
.nav.nav-tabs.full.select-pc-tab  {
    margin-bottom: 5px !important;
    li > a {
        display: flex;
        align-items: center;
        .helper-picker {
            height: 20px;
            width: 20px;
            border: solid 1px #8D29A0;
            border-radius: 50%;
            display: block;
            margin-right: 5px;
            transition: all .2s;
        }

        h5 {
            margin: 0;
        }
    }
    li.active a .helper-picker,
    .helper-picker:hover {
        border: solid 7px #8D29A0;
        background-color: white;
    }
}

.hue-ambient {
    li {
        float: none;

        &:nth-child(1) {
            &:before {
                content: "" !important;
            }
        }

        &:nth-child(2) {
            margin-top: 6px;
            a {
                padding-left: 0 !important;
            }
        }
    }
}

.part-description {
    position: relative;
    z-index: 1;
    color: #fff;
    margin: 0 0 10px;
}

</style>
